/* import __COLOCATED_TEMPLATE__ from './market-input-text-formatted.hbs.js'; */
var _dec, _class, _descriptor;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import Component from '@ember/component';
import { action, computed, set } from '@ember/object';
import { inject as service } from '@ember/service';
/**
 * MarketInputTextFormatted combines the functionality of sq-input-formatted into a
 * Market UI market-input-text element.
 * @param {any} value Value of the input
 * @param {string} [inputClassNames] Optional classes to apply to the input
 * @param {string} [placeholder] Optional placeholder text
 * @param {string} [tooltip] Optional clickable tooltip
 * @param {string} [type=text] Type of input
 * @param {string} [size] Optional for setting input size. Sizes small and medium visually hide the label, i.e. "large", "medium", "small"
 * @param {string} [inputmode] Optional hint to what type of input is expected
 * @param {boolean} [disabled=false]
 * @param {boolean} [autofocus=false]
 * @param {boolean} [autocomplete=true]
 * @param {boolean} [hideCurrencySymbol=false] Option to hide the currency symbol for rendered currency values
 * @param {function} [valueToStore]
 * @param {function} [valueToShow]
 * @param {function} [onChange]
 * @param {action} [didInsert] Optional function that will fire after the component is inserted and this.input is set
 * @param {action} [onFocus]
 * @param {action} [handleChange]
 * @param {function} [handleDidEndEditing]
 */
let MarketInputTextFormatted = (_dec = computed('value'), _class = class MarketInputTextFormatted extends Component {
  constructor(...args) {
    super(...args);
    // Passed in
    _defineProperty(this, "value", void 0);
    _defineProperty(this, "inputClassNames", void 0);
    _defineProperty(this, "tooltip", void 0);
    _defineProperty(this, "accessoryText", void 0);
    _defineProperty(this, "disabled", false);
    _defineProperty(this, "autofocus", false);
    _defineProperty(this, "autocomplete", true);
    _defineProperty(this, "type", 'text');
    _defineProperty(this, "size", void 0);
    _defineProperty(this, "hideCurrencySymbol", false);
    // Default service, if an optional is not passed in from the external wrapper component
    _initializerDefineProperty(this, "formatter", _descriptor, this);
    // Internal
    _defineProperty(this, "input", void 0);
  }
  onChange() {}
  onFocus() {}
  onBlur() {}
  get labelId() {
    return `market-input-label-${this.elementId}`;
  }
  get placeholder() {
    return null;
  }

  // These functions can be overridden by child components.
  // Value to return to onChange
  valueToStore(value) {
    return value;
  }

  // Value to display in the input
  valueToShow(value) {
    return value;
  }

  // Fires when component has been inserted into the DOM
  didInsert() {}

  // Fires on focus
  onFocusAction() {
    this.onFocus();
  }

  // Fires on blur
  onBlurAction() {
    this.onBlur();
  }

  // Fires after each input
  handleChange(value) {
    this.onChange(value);
  }

  // Fires on blur
  handleDidEndEditing() {
    const newValue = this.formatter?.format?.(this.input.value);
    set(this, 'value', newValue);
    this.onChange(this.valueToStore(newValue));
  }
  willDestroy(...args) {
    super.willDestroy(...args);
    this.input?.removeEventListener('change', this.handleDidEndEditing);
  }
  get displayValue() {
    return this.valueToShow(this.value);
  }
  async registerChangeHandler() {
    this.marketInput = this.element.querySelector('market-input-text');
    this.input = await this.marketInput.getInputElement();
    this.input.addEventListener('change', this.handleDidEndEditing);
    this.didInsert();
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "formatter", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "onFocusAction", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onFocusAction"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onBlurAction", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onBlurAction"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "handleChange", [action], Object.getOwnPropertyDescriptor(_class.prototype, "handleChange"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "handleDidEndEditing", [action], Object.getOwnPropertyDescriptor(_class.prototype, "handleDidEndEditing"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "displayValue", [_dec], Object.getOwnPropertyDescriptor(_class.prototype, "displayValue"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "registerChangeHandler", [action], Object.getOwnPropertyDescriptor(_class.prototype, "registerChangeHandler"), _class.prototype), _class);
export { MarketInputTextFormatted as default };